import { render, staticRenderFns } from "./IconSetting.vue?vue&type=template&id=0ad3951c"
import script from "./IconSetting.vue?vue&type=script&lang=js"
export * from "./IconSetting.vue?vue&type=script&lang=js"
import style0 from "./IconSetting.vue?vue&type=style&index=0&id=0ad3951c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports